import { Flex, Text } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import src from '@/assets/images/search.png';
import BaseClickable from '@/components/ui/BaseClickable';

import s from './TreeSearchEmptyState.module.scss';

type Props = {
  onReset: () => void;
};

const TreeSearchEmptyState: React.FC<Props> = ({ onReset }) => {
  return (
    <Flex direction="column" align="center" justify="center" className={s.root}>
      <img width={113} height={113} src={src} alt="empty" className={s.root__image} />
      <Text className={s.root__text} size="md">
        Нет результатов по вашему запросу
      </Text>
      <BaseClickable onClick={onReset}>
        <Text size="md" c="blue">
          Сбросить поиск
        </Text>
      </BaseClickable>
    </Flex>
  );
};

export default observer(TreeSearchEmptyState);
